<router-outlet></router-outlet>
<!-- This is only needed to start loading monaco editor as soon as possible -->
<app-json-editor
  class="!hidden"
  [vm]="{
    content: '',
  }"
/>
<app-connection-lost-overlay />
